/**
 * Static asset CDN origin (locale JSON, and same origin as JS/CSS/fonts when using PUBLIC_URL on build).
 *
 * Priority:
 * - REACT_APP_CDN_URL — same as CDN_CONFIGURATION.md (static build CDN)
 * - PUBLIC_URL — Create React App: if absolute URL, used for built bundle paths
 *
 * Example: https://file.espa247.com (no trailing slash)
 *
 * CORS: if the app runs on devpos.local.com and locales load from cdn.local.com, the CDN must
 * send Access-Control-Allow-Origin for your app origin (or * for dev).
 *
 * Dev + yarn start: CRA ignores CDN for asset URLs unless `craco.config.js` applies
 * `REACT_APP_CDN_URL` to file-loader / asset modules. You still need nginx (or similar) to
 * proxy `http://cdn.../static/` → `http://devpos...:3000/static/` so files exist while developing.
 */
export function getStaticAssetCdnOrigin(): string {
  const raw =
    process.env.REACT_APP_CDN_URL ||
    (typeof process.env.PUBLIC_URL === 'string' && /^https?:\/\//i.test(process.env.PUBLIC_URL)
      ? process.env.PUBLIC_URL
      : '') ||
    '';
  return raw.replace(/\/$/, '');
}

/** i18next-http-backend loadPath: full URL or same-origin relative path. */
export function getI18nLocalesLoadPath(): string {
  const base = getStaticAssetCdnOrigin();
  return base ? `${base}/locales/{{lng}}/{{ns}}.json` : '/locales/{{lng}}/{{ns}}.json';
}
